import { Button, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

const UrgeReload: React.FC = ()=> {
  const {t} = useTranslation()
  return <div style={{
    alignContent: 'center', alignItems: 'center', flexGrow: 1, minHeight: '60vh'
  }}>
    <div style={{textAlign: 'center'}}>
      <Typography color='inherit' variant='h5' fontSize={18} sx={{mb: 1}}>
        {t('urge_reload.title')}
      </Typography>
      <Typography color='gray' fontSize={13} whiteSpace='pre-wrap'>
        {t('urge_reload.description')}
      </Typography>
      <Button
        sx={{mt: 4}}
        variant='contained'
        color='primary'
        onClick={()=> { window.location.reload() }}
      >
        {t('urge_reload.reload')}
      </Button>
    </div>
  </div>
}
export default UrgeReload